import { useMutation, useQuery } from "@tanstack/react-query"
import { axiosDelete, axiosGet, axiosPatch, axiosPost } from "Redux/axiosHelper"
import { AddActivityStep2Body, AddActivityStep3Body, AddActivityStep4Body, CreateActivityStep1Body, EditActivityStep3Body, GetActivitiesQuery } from "types/Classes/Activities"
import { Step4CurriculumPayload, UpdateClassStep4Body } from "types/Classes/Classes"

const editClassesStep4 = async ({ body, classId }:
  { body: UpdateClassStep4Body, classId: string }) => {

  const response = await axiosPatch(body, `v1/edu-class/${classId}/step-4/schedule-temp`)
  return response.data
}

export const useEditClassStep4Mutation = () => {
  return useMutation(editClassesStep4)
}

const createUpdateActivity = async ({ body, classId }: { body: Step4CurriculumPayload, classId: string }) => {
  const response = await axiosPatch(body, `v1/edu-class/${classId}/manage-activity`)
  return response.data
}

export const useCreateUpdateActivityMutation = () => {
  return useMutation(createUpdateActivity)
}


//Create New Activity
const createClassNewActivity = async ({ body, organizationId }: { body: CreateActivityStep1Body, organizationId: string }) => {
  const response = await axiosPost(body, `v1/activity/step-1/${organizationId}`)
  return response.data
}

export const useCreateNewClassActivityMutation = () => {
  return useMutation(createClassNewActivity)
}

//Edit activity step-1
const editActivityStep1 = async ({ body, activityId }: { body: CreateActivityStep1Body, activityId: string }) => {
  const response = await axiosPatch(body, `v1/activity/step-1/${activityId}`)
  return response.data
}

export const useEditActivityStep1Mutation = () => {
  return useMutation(editActivityStep1)
}


//Add Activity Step-2
const addActivityStep2 = async ({ body, activityId }: { body: AddActivityStep2Body, activityId: string }) => {
  const response = await axiosPatch(body, `v1/activity/step-2/${activityId}`)
  return response.data
}

export const useAddActivityStep2Mutation = () => {
  return useMutation(addActivityStep2)
}


//Add Activity step-3
const addActivityStep3 = async ({ body, activityId }: { body: AddActivityStep3Body, activityId: string }) => {
  const response = await axiosPatch(body, `v1/activity/step-3-supplies/${activityId}`)
  return response.data
}

export const useAddActivityStep3Mutation = () => {
  return useMutation(addActivityStep3)
}


//Edit Activity step-3
const editActivityStep3 = async ({ body, activityId, supplyId }: { body: EditActivityStep3Body, activityId: string, supplyId: string }) => {
  const response = await axiosPatch(body, `v1/activity/step-3-supplies/${activityId}/${supplyId}`)
  return response.data
}

export const useEditActivityStep3Mutation = () => {
  return useMutation(editActivityStep3)
}

//Remove activity step-3
const removeActivityStep3 = async ({ activityId, supplyId }: { activityId: string, supplyId: string }) => {
  const response = await axiosDelete(`v1/activity/step-3-supplies/${activityId}/${supplyId}`)
  return response.data
}

export const useRemoveActivityStep3Mutation = () => {
  return useMutation(removeActivityStep3)
}


//Add Activity step-4
const addActivityStep4 = async ({ body, activityId }: { body: AddActivityStep4Body, activityId: string }) => {
  const response = await axiosPatch(body, `v1/activity/step-4-tasks/${activityId}`)
  return response.data
}

export const useAddActivityStep4Mutation = () => {
  return useMutation(addActivityStep4)
}


//Get Activities with organization query params
const getActivitiesWithOrganization = async ({
  organizationId,
  query,
}: {
  organizationId: string
  query?: GetActivitiesQuery
}) => {
  const response = await axiosGet(
    `v1/activity/list/${organizationId}`,
    query
  )
  return response.data
}

export const useGetActivitiesWithOrganizationQuery = (organizationId: string, query?: GetActivitiesQuery) => {
  return useQuery({
    queryKey: ['activities-list', organizationId, query],
    queryFn: () => getActivitiesWithOrganization({ organizationId, query }),
    enabled: !!organizationId,
  })
}


//Get Activity by ID
const getActivityById = async (activityId: string) => {
  const response = await axiosGet(`v1/activity/${activityId}`)
  return response.data
}

export const useGetActivityByIdQuery = (activityId: string) => {
  return useQuery({
    queryKey: ['activity-by-id', activityId],
    queryFn: () => getActivityById(activityId),
    enabled: !!activityId,
  })
}


//Delete Activity
const deleteActivity = async (activityId: string) => {
  const response = await axiosDelete(`v1/activity/${activityId}`)
  return response.data
}

export const useDeleteActivityMutation = () => {
  return useMutation({
    mutationFn: deleteActivity,
  })
}